import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '@2023重庆·我的新期待';
const baseUrl = '20221223XQD';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'known-people',
      name: `${baseUrl}-known-people`,
      component: () => import('./pages/KnownPeople.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'wish-rank',
      name: `${baseUrl}-wish-rank`,
      component: () => import('./pages/WishRank.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'wish-rank-county',
      name: `${baseUrl}-wish-rank-county`,
      component: () => import('./pages/WishRankCounty.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'media-focus',
      name: `${baseUrl}-media-focus`,
      component: () => import('./pages/MediaFocus.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'echo',
      name: `${baseUrl}-echo`,
      component: () => import('./pages/Echo.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'comments-with-tag',
      name: `${baseUrl}-comments-with-tag`,
      component: () => import('./pages/CommentListWithSpecificTag.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'comments-with-county',
      name: `${baseUrl}-comments-with-county`,
      component: () => import('./pages/CommentListWithCounty.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'user',
      name: `${baseUrl}-user`,
      component: () => import('./pages/User.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
